import Input from '@taglivros/oef_componentes/build/components/input'
import { validaEmailOuCPF } from '../../utils/validadores/validadores'
import { handleKeyPressRemoveEspaco } from '../../utils/helpers/helpers'
import { httpStatus } from '../../utils/request/httpStatus'
import { URLS } from '../../constants'

export const TITULO_PAGINA_LOGIN = 'Login'

export const TEXTO_BOTAO_LOGIN = 'Entrar'

export const CAMPOS_FORMULARIO_LOGIN = {
  'email': {
    'handleKeyPress': event => handleKeyPressRemoveEspaco( event ),
    'label': 'E-mail ou CPF',
    'obrigatorio': true,
    'tipoInput': Input.TIPO_TEXTO,
    'validador': email => validaEmailOuCPF( email )
  },
  'senha': {
    'handleKeyPress': event => handleKeyPressRemoveEspaco( event ),
    'isPassword': true,
    'label': 'Senha',
    'obrigatorio': true,
    'tipoInput': Input.TIPO_SENHA
  }
}

export const textoModalErroLogin = {
  [ httpStatus.BAD_REQUEST ]: {
    'descricao': 'Não foi possível entrar com as credenciais informadas, por favor, cheque se o seu e-mail e senha estão corretos e tente novamente.',
    'titulo': 'Credenciais incorretas'
  }
}

export const ROTA_ASSOCIA_SE = URLS.SITE

export const ROTA_ASSOCIA_SE_BOOKSTER = 'https://site.taglivros.com/checkout/?offer=e50d1a69-5628-412c-a980-50e63339b7ec'

export const AJUDA_LOGIN_BOOKSTER = {
  'titulo': 'Bem-vindo ao Bookster Pelo Mundo',
  'chamada': 'Sua próxima viagem literária começa por aqui.',
  'instrucoes': [
    {
      'pergunta': 'Já é associado TAG?',
      'resposta': 'Entre com o mesmo e-mail e senha que você usa na sua assinatura.',
      'destaque': true
    },
    {
      'pergunta': 'É o seu primeiro acesso?',
      'resposta': 'Use "Primeiro acesso / Esqueci minha senha" para criar a sua senha e embarcar.'
    }
  ]
}
